var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.093,
    height: 16.096,
    viewBox: "0 0 16.093 16.096",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.874,13.916,12.74,10.782a.754.754,0,0,0-.534-.22h-.512a6.535,6.535,0,1,0-1.132,1.132v.512a.754.754,0,0,0,.22.534l3.134,3.134a.751.751,0,0,0,1.066,0l.89-.89A.758.758,0,0,0,15.874,13.916ZM6.538,10.562a4.024,4.024,0,1,1,4.024-4.024A4.021,4.021,0,0,1,6.538,10.562Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1df565d2160432b1dca6258d0eb3e338.svg";
export { ForwardRef as ReactComponent };